import { Grid, Typography } from '@deere/fuel-react';
import { DateTime } from 'luxon';
import React from 'react';
import styles from './EmployeeInfo.module.css';

const LegacyBidRow = ({ empJobBid }) => (
    <Grid item xs={12} className={styles.legacyJobBidRow}>
        <Grid container className={styles.jobBidRowInner}>
            <Grid item sm={8} xs={12} className={styles.legacyJobBidRowTitle}>
                <span>
                    {empJobBid.jobClassification} #{empJobBid.jobNumber}{' '}
                </span>
                <span>- ({empJobBid.openings}) openings</span>
            </Grid>
            <Grid item sm={4} xs={12} className={styles.jobBidStatus}>
                <span>{empJobBid.bidStatus}</span>
            </Grid>
            <Grid item xs={12} className={styles.jobBidInfoSection}>
                <span>Facility: {empJobBid.facility}</span>
                <span>Department: {empJobBid.jobDept}</span>
                <span>Job Grade: {empJobBid.jobGrade}</span>
                <span>
                    Bid Close{' '}
                    {empJobBid.endDate
                        ? DateTime.fromISO(empJobBid.endDate).toFormat(
                              'LL/dd/yy'
                          )
                        : ''}
                </span>
            </Grid>
        </Grid>
    </Grid>
);

export const LegacyBidHistoryView = ({ bids }) => (
    <Grid container spacing={4} className={styles.bidGridSection}>
        <Grid item sm={12}>
            <Typography fontWeight="semibold" variant="h4" color="#367C2B">
                Bids ({bids.length})
            </Typography>
        </Grid>
        {bids.map((eachRow) => (
            <LegacyBidRow key={eachRow.jobNumber} empJobBid={eachRow} />
        ))}
    </Grid>
);
